import Bowser from 'bowser'
const browserInfo = Bowser.parse(window.navigator.userAgent)

export function getDeviceInfoBasedOnBrowser() {
    const deviceName = getDeviceName()
    const device = getOsName() || deviceName
    const osVersion = getOsVersion()
    const vendor = getVendor()

    return {
        device,
        deviceName,
        osVersion,
        vendor,
    }
}

export function isDesktop() {
    const osList = ['chromeos']
    const osname = (getOsName() || '').toLowerCase().replaceAll(' ', '')
    return (
        browserInfo.platform.type === 'desktop' ||
        osList.some((os) => osname.includes(os))
    )
}

export function getDeviceName() {
    return `WebCamera`
}
function getOsVersion() {
    const majorVersionRegex = /([0-9]*)(\.)?/
    let version = browserInfo.browser.version
    if (majorVersionRegex.test(version)) {
        // @ts-ignore
        version = majorVersionRegex.exec(version)[1]
    }
    return `${browserInfo.browser.name}_${version}`
}
function getOsName() {
    return browserInfo.os.name
}
function getVendor() {
    return `${browserInfo.os.name}_${browserInfo.os.version}`
}

/**
 *
 *
 * @param {Object} Params
 * @param {String} Params.email
 * @returns
 */
export function getJid({ email, deviceId }) {
    const deviceName = getDeviceName()

    const jid = `${email}/${deviceId}`
    return { jid, deviceId, deviceName }
}

export function generateDeviceId() {
    const deviceName = getDeviceName()
    return `ivuu11${deviceName}${randomChar(12)}`
}

/**
 *
 *
 * @param {Number} length
 * @returns
 */
function randomChar(length) {
    var result = ''
    var characters = 'ABCDEF0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        )
    }
    return result
}

export function detectBrowserSupport() {
    if (browserInfo.browser.name !== 'Chrome') {
        return 'wrongBrowser'
    }
    if (Number(browserInfo.browser.version.split('.')[0]) < 79) {
        return 'updateBrowser'
    }
    return true
}
